import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = { href: "#login" }
const _hoisted_2 = {
  key: 9,
  class: "text-input__error-message text-input__error-message--global"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { href: "" }

import { computed, ref, watch } from "vue";
import dictionary from "@/i18n/dictionary.json";
import { EmailValidatorResult, RegisterAccountPrivate } from "@/models/AccountRegister";
import TressTextInput from "@/components/TressTextInput.vue";
import { MemberApi } from "@/services/Api";
import TressFormSuccess from "@/components/TressFormSuccess.vue";
import { Validator } from "@/code/Validator";
import { useI18n } from "vue-i18n";
import TressAlert from "@/components/TressAlert.vue";
import { TressExceptions } from "@/code/TressExceptions";
import TressException from "@/services/TressException";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressAccountRegisterPrivateForm',
  emits: ["success"],
  setup(__props, { emit: emits }) {

const $t = useI18n().t;


const hasSuccess = ref<boolean>(false);
const isSending = ref<boolean>(false);
const userAlreadyExists = ref<boolean>(false);
const migrationUserExists = ref<boolean>(false);
const form = ref();
const queryParams = new URLSearchParams(window.location.search);
const returnUrl = ref(queryParams.get("returnUrl"));

const onSubmit = async (values) => {
  try {
    isSending.value = true;

    if (migrationUserExists.value) {
      hasSuccess.value = await MemberApi.migrateAccount(register.value.email, register.value.name, "private");
      emits("success");
    } else {
      values.type = "private";
      hasSuccess.value = await MemberApi.registerAccountPrivate(values);
      emits("success");
      setTimeout(() => {
        if (returnUrl.value) {
          window.location.href = returnUrl.value;
        }
      }, 30000);
    }
  } catch (error: unknown) {
    switch (TressException(error)) {
      case TressExceptions.Register_AlreadyLoggedIn:
        form.value.setFieldError("", $t(dictionary.form.error.alreadyLoggedIn));
        break;
      case TressExceptions.Register_EmailAlreadyExists:
        form.value.setFieldError("email", $t(dictionary.form.error.emailAlreadyExists));
        break;
      case TressExceptions.Register_InvalidMailAddress:
        form.value.setFieldError("email", $t(dictionary.form.error.invalidMailAddress));
        break;
      case TressExceptions.Register_InvalidPassword:
        form.value.setFieldError("password", $t(dictionary.form.error.invalidPassword));
        break;
      case TressExceptions.Register_MissingName:
        form.value.setFieldError("name", $t(dictionary.form.error.missingName));
        break;
      case TressExceptions.Register_MissingPhoneNumber:
        form.value.setFieldError("phoneNumber", $t(dictionary.form.error.missingPhoneNumber));
        break;
      case TressExceptions.Register_PasswordsMustMatch:
        form.value.setFieldError("password2", $t(dictionary.form.error.passwordMustMatch));
        break;
      case TressExceptions.Register_MissingCustomerAddress:
        form.value.setFieldError("customerAddress", $t(dictionary.form.error.missingCustomerAddress));
        break;
      case TressExceptions.Register_MissingCustomerZip:
        form.value.setFieldError("customerPostalCode", $t(dictionary.form.error.missingCustomerZip));
        break;
      case TressExceptions.Register_MissingCustomerCity:
        form.value.setFieldError("customerCity", $t(dictionary.form.error.missingCustomerCity));
        break;
      case TressExceptions.Unknown_Error:
      default:
        form.value.setFieldError("", $t(dictionary.form.error.unknownError));
        break;
    }
  } finally {
    isSending.value = false;
  }
};
const register = ref<RegisterAccountPrivate>({} as RegisterAccountPrivate);
watch(
  () => register.value.email,
  async (currVal) => {
    const validationResult = await Validator.emailValidate(currVal);
    if (Number(EmailValidatorResult[validationResult]) == EmailValidatorResult.UmbracoUserExists) {
      userAlreadyExists.value = true;
    } else if (Number(EmailValidatorResult[validationResult]) == EmailValidatorResult.MigrationUserExists) {
      migrationUserExists.value = true;
    }
  }
);
const newRegistration = computed(() => {
  return !migrationUserExists.value;
});
const submitButtonText = computed(() => {
  if (migrationUserExists.value) {
    return $t(dictionary.account.migrateAccount);
  } else {
    return $t(dictionary.account.createAccount);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_form = _resolveComponent("v-form")!

  return (!hasSuccess.value)
    ? (_openBlock(), _createBlock(_component_v_form, {
        key: 0,
        ref_key: "form",
        ref: form,
        class: "register-private-form",
        onSubmit: onSubmit
      }, {
        default: _withCtx(({ errors }) => [
          _createVNode(TressTextInput, {
            modelValue: register.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((register.value.name) = $event)),
            label: _unref($t)(_unref(dictionary).form.name.label),
            name: "name",
            rules: "required"
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.name.label)), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "label"]),
          _createVNode(TressTextInput, {
            modelValue: register.value.email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((register.value.email) = $event)),
            label: _unref($t)(_unref(dictionary).form.email.label),
            name: "email",
            rules: "required|email"
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.email.label)), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "label"]),
          (userAlreadyExists.value)
            ? (_openBlock(), _createBlock(TressAlert, {
                key: 0,
                success: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.alreadyHaveAnAccount)) + " ", 1),
                  _createElementVNode("a", _hoisted_1, _toDisplayString(_unref($t)(_unref(dictionary).form.loginHere)), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (migrationUserExists.value)
            ? (_openBlock(), _createBlock(TressAlert, {
                key: 1,
                success: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.migrationUserExists)), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 2,
                modelValue: register.value.customerAddress,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((register.value.customerAddress) = $event)),
                label: _unref($t)(_unref(dictionary).form.customerAddress.label),
                name: "customerAddress",
                rules: "required"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerAddress.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 3,
                modelValue: register.value.customerAddress2,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((register.value.customerAddress2) = $event)),
                label: _unref($t)(_unref(dictionary).form.customerAddress2.label),
                name: "customerAddress2"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerAddress2.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 4,
                modelValue: register.value.customerPostalCode,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((register.value.customerPostalCode) = $event)),
                label: _unref($t)(_unref(dictionary).form.customerZip.label),
                class: "register-business-form__input register-business-form__input--half",
                name: "customerPostalCode",
                rules: { required: true, regex: _unref(Validator).zipCodeRules() }
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerZip.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label", "rules"]))
            : _createCommentVNode("", true),
          (newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 5,
                modelValue: register.value.customerCity,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((register.value.customerCity) = $event)),
                label: _unref($t)(_unref(dictionary).form.customerCity.label),
                class: "register-business-form__input register-business-form__input--half",
                name: "customerCity",
                rules: "required"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerCity.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 6,
                modelValue: register.value.phoneNumber,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((register.value.phoneNumber) = $event)),
                label: _unref($t)(_unref(dictionary).form.phoneNumber.label),
                name: "phoneNumber",
                rules: { required: true, regex: /^\d*$/ }
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.phoneNumber.placeholder)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 7,
                modelValue: register.value.password,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((register.value.password) = $event)),
                label: _unref($t)(_unref(dictionary).form.password.label),
                name: "password",
                rules: "required",
                type: "password"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.password.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 8,
                modelValue: register.value.password2,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((register.value.password2) = $event)),
                label: _unref($t)(_unref(dictionary).form.password2.label),
                name: "password2",
                rules: { required: true, confirmed: { target: '@password' } },
                type: "password"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.password2.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_v_field, { name: "" }, null, 512), [
            [_vShow, false]
          ]),
          (errors[''])
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(errors[""]), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            disabled: isSending.value,
            class: "button register-private-form__submit-button"
          }, _toDisplayString(submitButtonText.value), 9, _hoisted_3)
        ]),
        _: 1
      }, 512))
    : (_openBlock(), _createBlock(_Teleport, {
        key: 1,
        to: "#success-container"
      }, [
        _createVNode(TressFormSuccess, null, {
          header: _withCtx(() => [
            (migrationUserExists.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref($t)(_unref(dictionary).account.migrateAccountSuccessHeader)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref($t)(_unref(dictionary).account.registerAccountSuccessHeader)), 1))
          ]),
          description: _withCtx(() => [
            (migrationUserExists.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref($t)(_unref(dictionary).account.migrateAccountSuccessDescription)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).account.registerAccountSuccessDescription)) + " ", 1),
                  _createElementVNode("a", _hoisted_8, _toDisplayString(_unref($t)(_unref(dictionary).common.clickHere)), 1)
                ]))
          ]),
          _: 1
        })
      ]))
}
}

})